import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { AlertIcon } from '../../shared';
import { CardModule } from "primeng/card";
import { ButtonDirective } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormGroupErrorMessageComponent } from '../form-group-error-message/form-group-error-message.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertService } from '../../services';

export interface IsearchJefeHogar {
  tipoIdentificacion: string;
  identificacion: string;
}

@Component({
  selector: 'app-buscar-sisben',
  standalone: true,
  imports: [
    CardModule,
    ButtonDirective,
    DropdownModule,
    InputNumberModule,
    ReactiveFormsModule,
    FormGroupErrorMessageComponent,
    TranslatePipe
  ],
  styles:`
    .buscar__wrapper {
      padding: 0 3rem;
    }
  `,
  template: `
  <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="buscar__wrapper">
    <div class="grid p-fluid">
      @if (!hiddenTitle) {
        <h1 class="col-12 font-principal app-title-page-color
      font-medium font-18 text-uppercase mt-2">Buscar por identificación</h1>
      }
      <div class="col-12 md:col-6">
        <label for="tipoIdentificacion" class="font-bold">{{ 'common.tipoIdentificacion' | translate }}</label>
        <p-dropdown id="tipoIdentificacion" [options]="tiposIdentificaciones"
                    formControlName="tipoIdentificacion" optionValue="id"
                    optionLabel="descripcion" [showClear]="true"
                    placeholder="Seleccione un tipo de identificación"/>
        @if (searchForm.get('tipoIdentificacion')?.invalid && searchForm.get('tipoIdentificacion')?.touched) {
          <app-form-group-error-message
            [control]="searchForm.get('tipoIdentificacion')"/>
        }
      </div>

      <div class="col-12 md:col-6">
        <label for="identificacion" class="font-bold">{{ 'common.identificacion' | translate }}</label>
        <p-inputNumber inputId="identificacion" formControlName="identificacion"
                      [useGrouping]="false" mode="decimal"
                      placeholder="Ingrese el número de documento"/>
        @if (searchForm.get('identificacion')?.invalid && searchForm.get('identificacion')?.touched) {
          <app-form-group-error-message [control]="searchForm.get('identificacion')"/>
        }
      </div>

      <div class="col-12 mt-3 flex gap-2 justify-content-end">
        <button pButton label="{{'form.button.limpiar' | translate }}"
                icon="pi pi-times" type="button" (click)="onClean()"
                class=" p-button-outlined w-fit"></button>
        <button pButton label="{{'form.button.buscar' | translate }}"
                icon="pi pi-search" type="submit" [disabled]="disabledSubmit"
                class=" p-button-outlined w-fit"></button>

      </div>
    </div>
  </form>
  `
})
export class BuscarSisbenComponent {
  @Input() tiposIdentificaciones !: any[];
  @Input() hiddenTitle: boolean = false;
  @Output() sisben: EventEmitter<IsearchJefeHogar> = new EventEmitter();
  @Output() clearSearch: EventEmitter<void> = new EventEmitter();

  searchForm!: FormGroup;
  existData: boolean = false;

  constructor(
    private alertService: AlertService
  ) {
    this.initForm()
  }

  private initForm() {
    this.searchForm = new FormGroup({
      identificacion: new FormControl<number | null>(null, Validators.required),
      tipoIdentificacion: new FormControl<string | null>(null, Validators.required)
    })
  }

  onSubmit() {
    if (this.existData) {
      this.questionExist().then(data => {
        if (data?.accept) {
          this.clearSearch.emit();
          this.sisben.emit(this.searchForm.value);
        }
      });
      return;
    }
    this.sisben.emit(this.searchForm.value);
  }

  async onClean(): Promise<void> {
    if (this.existData) {
      await this.questionExist().then((result: any) => {
        if (result?.accept) {
          this.searchForm.reset();
          this.clearSearch.emit();
        }
      })
    } else {
      this.searchForm.reset();
      this.clearSearch.emit();
    }
  }

  private async questionExist(): Promise<any> {
    return firstValueFrom(this.alertService.show({
      icon: AlertIcon.QUESTION,
      title: '¿Está seguro de que desea limpiar todos los campos?',
      text: 'Esta acción no se puede deshacer.',
      showAccept: true,
      showCancel: true
    })).then()
  }

  get disabledSubmit(): boolean {
    return this.searchForm.invalid;
  }
}
